/**
 * <s-footer-accordion> — footer link columns as accordions below the lg breakpoint.
 *
 * Markup: <details data-footer-acc> elements, each with a <summary> heading and its link list.
 * Below 1024px the columns start closed and toggle on tap (opening one closes the others).
 * From 1024px every column is forced open and the summary no longer toggles, so desktop keeps
 * the plain column layout. Without JS the columns render open (they ship with the open attribute).
 */
class SFooterAccordion extends HTMLElement {
  #ac;
  #mq = window.matchMedia('(min-width: 1024px)');

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    this.#mq.addEventListener('change', this.#sync, opts);
    this.addEventListener('click', this.#onClick, opts);
    this.addEventListener('toggle', this.#onToggle, { ...opts, capture: true });
    this.#sync();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  get #items() {
    return [...this.querySelectorAll('details[data-footer-acc]')];
  }

  #sync = () => {
    const desktop = this.#mq.matches;
    for (const item of this.#items) item.open = desktop;
  };

  #onClick = (event) => {
    if (!this.#mq.matches) return;
    const summary = event.target instanceof Element ? event.target.closest('summary') : null;
    if (summary && this.contains(summary)) event.preventDefault();
  };

  #onToggle = (event) => {
    if (this.#mq.matches) return;
    const opened = event.target;
    if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;
    for (const item of this.#items) {
      if (item !== opened) item.open = false;
    }
  };
}

if (!customElements.get('s-footer-accordion')) {
  customElements.define('s-footer-accordion', SFooterAccordion);
}
